import BaseAPI from './BaseAPI';

// The exception list — everything the software could not settle on its own.
class AttentionAPI extends BaseAPI {
  constructor() { super('attention'); }

  // GET /attention?start=&end= → { range, groups, total, payments }
  list(start, end) {
    return this.get(`/?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end || start)}`);
  }
}

export const AttentionService = new AttentionAPI();
export default AttentionAPI;
